import dayjs from 'dayjs';
import { getStringValue, isExcluded } from 'utils/search';
import { formatMonthDate } from '../helpers';

export const TRADESHOW_CALENDAR_EXPORT_LIMIT = 5000;

export const isTradeshowCalendarExportTooLarge = count =>
  count > TRADESHOW_CALENDAR_EXPORT_LIMIT;

export const tooLargeTooltip =
  'This export is too large to process. Please reduce the Tradeshow count to below 5K.';

export const tradeshowStatusByLabel = {
  active: 1,
  postponed: 2,
  cancelled: 3,
  completed: 4,
  upcoming: 5,
  ongoing: 6,
  tbc: 7,
};

export const tradeshowPlatformStatusByLabel = {
  'in platform': 0,
  pending: 1,
};

export const tradeshowRegisterInterestByLabel = {
  'currently registered interest': 0,
  'all registered interest': 1,
  none: 2,
};

export const tradeshowEventFormatByLabel = {
  'in-person': 0,
  hybrid: 1,
  virtual: 2,
  tbc: 3,
};

export const buildTradeshowCalendarExportBody = ({
  filteredData = [],
  filters = {},
}) => {
  const {
    name,
    year,
    startDate,
    month,
    city,
    regionCountry,
    state,
    tradeshowStatus,
    platformStatus,
    registeredInterest,
    tradeshowEventFormat,
  } = filters;

  const monthDate = formatMonthDate(year, month);
  const structuredSearch = {
    ...filters,
    tradeshowDate: startDate,
  };

  const body = {
    tradeshowIds: filteredData.map(tradeshow => tradeshow.id),
    structuredSearch: JSON.stringify(structuredSearch),
    tradeShowName: name != null ? String(name).trim() : '',
    year,
    month: monthDate ? monthDate : undefined,
    startDate: startDate ? dayjs(startDate[0]).format('YYYY-MM-DD') : undefined,
    endDate: startDate ? dayjs(startDate[1]).format('YYYY-MM-DD') : undefined,
    cities: city?.filter(c => !isExcluded(c))?.map(c => c) ?? [],
    citiesExcluded: city
      ?.filter(c => isExcluded(c))
      ?.map(c => getStringValue(c)),
    states: state?.filter(s => !isExcluded(s))?.map(s => s),
    statesExcluded: state?.filter(s => isExcluded(s))?.map(s => s),
    regionCountries: regionCountry?.filter(c => !isExcluded(c))?.map(c => c),
    regionCountriesExcluded: regionCountry
      ?.filter(c => isExcluded(c))
      ?.map(c => getStringValue(c)),
    tradeshowStatuses: (tradeshowStatus?.filter(s => !isExcluded(s)) ?? [])
      .map(
        raw =>
          tradeshowStatusByLabel[
            String(getStringValue(raw))
              .trim()
              .toLowerCase()
          ]
      )
      .filter(n => n !== undefined),
    tradeshowStatusesExcluded: (
      tradeshowStatus?.filter(s => isExcluded(s)) ?? []
    )
      .map(
        raw =>
          tradeshowStatusByLabel[
            String(getStringValue(raw))
              .trim()
              .toLowerCase()
          ]
      )
      .filter(n => n !== undefined),
    platformStatuses: (platformStatus?.filter(s => !isExcluded(s)) ?? [])
      .map(
        raw =>
          tradeshowPlatformStatusByLabel[
            String(getStringValue(raw))
              .trim()
              .toLowerCase()
          ]
      )
      .filter(n => n !== undefined),
    platformStatusesExcluded: (platformStatus?.filter(s => isExcluded(s)) ?? [])
      .map(
        raw =>
          tradeshowPlatformStatusByLabel[
            String(getStringValue(raw))
              .trim()
              .toLowerCase()
          ]
      )
      .filter(n => n !== undefined),
    registeredInterests: (registeredInterest?.filter(s => !isExcluded(s)) ?? [])
      .map(
        raw =>
          tradeshowRegisterInterestByLabel[
            String(getStringValue(raw))
              .trim()
              .toLowerCase()
          ]
      )
      .filter(n => n !== undefined),
    registeredInterestsExcluded: (
      registeredInterest?.filter(s => isExcluded(s)) ?? []
    )
      .map(
        raw =>
          tradeshowRegisterInterestByLabel[
            String(getStringValue(raw))
              .trim()
              .toLowerCase()
          ]
      )
      .filter(n => n !== undefined),
    tradeshowEventFormats: (
      tradeshowEventFormat?.filter(s => !isExcluded(s)) ?? []
    )
      .map(
        raw =>
          tradeshowEventFormatByLabel[
            String(getStringValue(raw))
              .trim()
              .toLowerCase()
          ]
      )
      .filter(n => n !== undefined),
    tradeshowEventFormatsExcluded: (
      tradeshowEventFormat?.filter(s => isExcluded(s)) ?? []
    )
      .map(
        raw =>
          tradeshowEventFormatByLabel[
            String(getStringValue(raw))
              .trim()
              .toLowerCase()
          ]
      )
      .filter(n => n !== undefined),
  };

  return body;
};
